import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import CheckboxToggleController from './controllers/checkbox-toggle-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import DatePickerController from './controllers/date-picker-controller';
import ExpandableController from './controllers/expandable-controller';
import LeafletController from './controllers/leaflet-maps-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import TabController from './controllers/tab-controller';
import FilterController from './controllers/filter-controller';
import RatingController from './controllers/rating-controller';
import AutocompleteController from './controllers/autocomplete-controller';

require('./navigation');
require('./auth');
require('./main');

const application = Application.start();

application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('checkbox-toggle', CheckboxToggleController);
application.register('cookie-bar', CookieBarController);
application.register('date-picker', DatePickerController);
application.register('modal', ModalController);
application.register('tab', TabController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('leaflet', LeafletController);
application.register('filter', FilterController);
application.register('rating', RatingController);
application.register('autocomplete', AutocompleteController);


function symptoms(){
    jQuery('#content .analizator.size_1 .navi > li > a').on('click',function (e) {
        e.preventDefault();
        jQuery('#content .analizator.size_1 .navi > li > a.act-temp').removeClass('open');
        jQuery('#content .analizator.size_1 .navi > li > a.act-temp').addClass('close');
        jQuery('#content .analizator.size_1 .navi > li > a.act-temp').next('ul').hide();
        jQuery('#content .analizator.size_1 .navi > li > a.act-temp').removeClass('act-temp');
        jQuery('#content .analizator .scroll_box_1 li').hide();
        if(jQuery(this).hasClass('close')){
            jQuery(this).removeClass('close');
            jQuery(this).addClass('open');
            jQuery(this).addClass('act-temp');
            jQuery(this).next('ul').show();
        }else{
            jQuery(this).removeClass('open');
            jQuery(this).addClass('close');
            jQuery(this).next('ul').hide();
        }

    });
    jQuery('#content .analizator .navi > li ul li a').on('click',function (e) {
        e.preventDefault();
        // show level 3 symptoms
        jQuery('#content .analizator .navi > li ul li a').removeClass('act');
        jQuery(this).addClass('act');
        var id = jQuery(this).attr('data-id');
        jQuery('#content .analizator .scroll_box_1 li').hide();
        jQuery('#content .analizator .scroll_box_1 li#parent-'+id).show();
    });
    jQuery('#content .analizator .scroll_box_1 li a').on('click',function (e) {
        e.preventDefault();
        if(jQuery(this).hasClass('act')){
            var id = jQuery(this).attr('data-id');
            jQuery('#content .analizator .scroll_box_2 .hold ul a[data-id="'+id+'"]').parent().remove();
        }else{
            var el = jQuery(this).parent().clone();
            jQuery('#content .analizator .scroll_box_2 .hold ul').append(el);
            jQuery('#content .analizator .scroll_box_2 .hold ul li').attr('id','');
        }
        jQuery(this).toggleClass('act');
        symptomsRemove();
        showDeseases();
    });

}

function symptomsRemove(){
    jQuery('#content .analizator .scroll_box_2 li a').on('click',function (e) {
        e.preventDefault();
        var id = jQuery(this).attr('data-id');
        jQuery('#content .analizator .scroll_box_1 li a[data-id="'+id+'"]').removeClass('act');
        jQuery(this).parent().remove();
        showDeseases();
    });
}

function showDeseases(){

    var content = '';
    var ids = '';
    var id = '';

    jQuery( "#content .analizator .scroll_box_2 .hold li" ).each(function( index, element ) {
        // element == this
        id = jQuery( element ).find('a').attr('data-id');
        ids = ids + id + ', ';
    });

    jQuery.ajax({
        cache: false,
        dataType: 'html',
        type: 'GET',
        url : "/wp-admin/admin-ajax.php?ids="+ids,
        data : {action: "get_data"},
        beforeSend: function () {

        },
        error: function () {

        },
        success: function (response) {
            jQuery('#content .analizator.size_2 .navi').html(response);
        }
    });

}

jQuery('document').ready(function () {
    symptoms();
});
